import { gql } from '@apollo/client'

export default gql`
  fragment AppraisalSeason on Meeting {
    appraisalSeason {
      id
      companyId
      country
      year
      fromDate
      toDate
    }
  }
`
